/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { productAdminControllerCreateV1 } from '../fn/product-admin/product-admin-controller-create-v-1';
import { ProductAdminControllerCreateV1$Params } from '../fn/product-admin/product-admin-controller-create-v-1';
import { productAdminControllerDeleteV1 } from '../fn/product-admin/product-admin-controller-delete-v-1';
import { ProductAdminControllerDeleteV1$Params } from '../fn/product-admin/product-admin-controller-delete-v-1';
import { productAdminControllerFindByIdV1 } from '../fn/product-admin/product-admin-controller-find-by-id-v-1';
import { ProductAdminControllerFindByIdV1$Params } from '../fn/product-admin/product-admin-controller-find-by-id-v-1';
import { productAdminControllerReorderV1 } from '../fn/product-admin/product-admin-controller-reorder-v-1';
import { ProductAdminControllerReorderV1$Params } from '../fn/product-admin/product-admin-controller-reorder-v-1';
import { productAdminControllerSearchV1 } from '../fn/product-admin/product-admin-controller-search-v-1';
import { ProductAdminControllerSearchV1$Params } from '../fn/product-admin/product-admin-controller-search-v-1';
import { productAdminControllerToggleExposureV1 } from '../fn/product-admin/product-admin-controller-toggle-exposure-v-1';
import { ProductAdminControllerToggleExposureV1$Params } from '../fn/product-admin/product-admin-controller-toggle-exposure-v-1';
import { productAdminControllerUpdateV1 } from '../fn/product-admin/product-admin-controller-update-v-1';
import { ProductAdminControllerUpdateV1$Params } from '../fn/product-admin/product-admin-controller-update-v-1';
import { ProductDto } from '../models/product-dto';

@Injectable({ providedIn: 'root' })
export class ProductAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productAdminControllerSearchV1()` */
  static readonly ProductAdminControllerSearchV1Path = '/api/v1/products/admin';

  /**
   * Search products (admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerSearchV1$Response(params: ProductAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = productAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search products (admin).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerSearchV1(params: ProductAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.productAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `productAdminControllerCreateV1()` */
  static readonly ProductAdminControllerCreateV1Path = '/api/v1/products/admin';

  /**
   * Create product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productAdminControllerCreateV1$Response(params: ProductAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = productAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productAdminControllerCreateV1(params: ProductAdminControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.productAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `productAdminControllerFindByIdV1()` */
  static readonly ProductAdminControllerFindByIdV1Path = '/api/v1/products/admin/{id}';

  /**
   * Find product detail (admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerFindByIdV1$Response(params: ProductAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    const obs = productAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Find product detail (admin).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerFindByIdV1(params: ProductAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<ProductDto> {
    const resp = this.productAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productAdminControllerDeleteV1()` */
  static readonly ProductAdminControllerDeleteV1Path = '/api/v1/products/admin/{id}';

  /**
   * Delete product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerDeleteV1$Response(params: ProductAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = productAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerDeleteV1(params: ProductAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.productAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `productAdminControllerUpdateV1()` */
  static readonly ProductAdminControllerUpdateV1Path = '/api/v1/products/admin/{id}';

  /**
   * Update product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productAdminControllerUpdateV1$Response(params: ProductAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = productAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productAdminControllerUpdateV1(params: ProductAdminControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.productAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `productAdminControllerReorderV1()` */
  static readonly ProductAdminControllerReorderV1Path = '/api/v1/products/admin/reorder';

  /**
   * Reorder products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productAdminControllerReorderV1$Response(params: ProductAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = productAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reorder products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productAdminControllerReorderV1(params: ProductAdminControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.productAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `productAdminControllerToggleExposureV1()` */
  static readonly ProductAdminControllerToggleExposureV1Path = '/api/v1/products/admin/{id}/toggle-exposure';

  /**
   * Toggle product exposure.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAdminControllerToggleExposureV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerToggleExposureV1$Response(params: ProductAdminControllerToggleExposureV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = productAdminControllerToggleExposureV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Toggle product exposure.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAdminControllerToggleExposureV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAdminControllerToggleExposureV1(params: ProductAdminControllerToggleExposureV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.productAdminControllerToggleExposureV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
